import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more-vertical",
  "use": "icon-more-vertical-usage",
  "viewBox": "0 0 80 320",
  "content": "<symbol viewBox=\"0 0 80 320\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-more-vertical\"><path d=\"M80 40C80 17.998 62.002 0 40 0S0 17.998 0 40s17.998 40 40 40 40-17.998 40-40zm0 240c0-22.002-17.998-40-40-40S0 257.998 0 280s17.998 40 40 40 40-17.998 40-40zm0-120c0-22.002-17.998-40-40-40S0 137.998 0 160s17.998 40 40 40 40-17.998 40-40z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol